import { render, staticRenderFns } from "./Forbidden.vue?vue&type=template&id=128d60b7&scoped=true&"
import script from "./Forbidden.vue?vue&type=script&lang=ts&"
export * from "./Forbidden.vue?vue&type=script&lang=ts&"
import style0 from "./Forbidden.vue?vue&type=style&index=0&id=128d60b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128d60b7",
  null
  
)

export default component.exports